import script from "./nongyecx.vue?vue&type=script&setup=true&lang=js"
export * from "./nongyecx.vue?vue&type=script&setup=true&lang=js"

import "./nongyecx.vue?vue&type=style&index=0&id=e7ab3642&lang=less&scoped=true"
script.__scopeId = "data-v-e7ab3642"

export default script